import template from "./entity-business-product-modal.html";
import "./entity-business-product-modal.less";
import { EVENT_LOGOUT } from "../../../../../../../../constants";
import swal from "sweetalert2";
import { isStringNullishOrEmpty } from "../../../../../../../../services/string-service";

export function controller(loadingService, eventBus, $scope, $logger) {
	const ctrl = this;

	ctrl.templates = [
		{ label: "Gas", template: "gas" },
		{ label: "Diesel", template: "diesel" },
		{ label: "Ice", template: "ice" },
		{ label: "Slip Rent", template: "slip-rent" },
		{ label: "Bait", template: "bait" },
		{ label: "Gloves", template: "gloves" },
		{ label: "Salt", template: "salt" },
		{ label: "Supplies", template: "supplies" },
		{ label: "Misc", template: "misc" }
	];

	ctrl.promiseTracker = loadingService.getTracker();

	ctrl.$onDestroy = ctrl.cancel;

	ctrl.$onInit = () => {
		ctrl.product = { ...ctrl.resolve.product };
		eventBus.register(EVENT_LOGOUT, () => { ctrl.cancel(); }, $scope);

		ctrl.resolve.charges.forEach(c => {
			c.isSelected = (ctrl.product.Fees ?? []).some(f => f.Fee.Code === c.Code);
		});
	};

	ctrl.onOk = async() => {
		if(!validate()) {
			return;
		}

		ctrl.product.Fees = ctrl.resolve.charges
			.filter(c => c.isSelected)
			.map(c => ({ Fee: c }));

		const result = await ctrl.resolve.save(ctrl.product);
		ctrl.modalInstance.close(result);
	};

	ctrl.cancel = () => {
		ctrl.modalInstance.dismiss();
	};

	ctrl.setTemplate = (templateName) => {
		switch(templateName) {
			case "gas": {
				ctrl.product.Name = "Gas";
				ctrl.product.Unit = "Gallon";

				break;
			}
			case "diesel": {
				ctrl.product.Name = "Diesel";
				ctrl.product.Unit = "Gallon";

				break;
			}
			case "ice": {
				ctrl.product.Name = "Ice";
				ctrl.product.Unit = "Pound";

				break;
			}
			case "slip-rent": {
				ctrl.product.Name = "Slip Rent";
				ctrl.product.Unit = "Day";

				break;
			}
			case "bait": {
				ctrl.product.Name = "Bait";
				ctrl.product.Unit = "Pound";

				break;
			}
			case "gloves": {
				ctrl.product.Name = "Gloves";
				ctrl.product.Unit = "Pair";

				break;
			}
			case "salt": {
				ctrl.product.Name = "Salt";
				ctrl.product.Unit = "Pound";

				break;
			}
			case "supplies": {
				ctrl.product.Name = "Supplies";
				ctrl.product.Unit = "Each";

				break;
			}
			case "misc": {
				ctrl.product.Name = "Misc";
				ctrl.product.Unit = "Each";

				break;
			}
			default:
				break;
		}
	};

	function validate() {
		const validationStrings = [];

		if(isStringNullishOrEmpty(ctrl.product.Name)) {
			validationStrings.push("Product name is required.");
		}

		if(isStringNullishOrEmpty(ctrl.product.Price?.toString())) {
			validationStrings.push("Product price is required.");
		}

		if(isStringNullishOrEmpty(ctrl.product.Unit)) {
			validationStrings.push("Product unit is required.");
		}

		if(validationStrings.length > 0) {
			const errorList = `<ul><li>${validationStrings.join("</li><li>")}</li></ul>`;
			
			swal.fire({
				title: "Missing required fields",
				html: 
					`<p>Please correct the following errors</p>
					${errorList}
					`,
				showCloseButton: true,
				type: "warning"
			});
			
			return false;
		}

		return true;
	}
}

export default angular.module("vesl.components.entity-business-product-modal", [])
	.component("entityBusinessProductModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			reload: "&"
		}
	})
	.name;
